const INFO = {
	main: {
		title: "Vikas's Portfolio",
		name: "Vikas Agrahari",
		email: "vikasagrahari11111@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://x.com/agrahariv647",
		github: "https://github.com/Vikas-Agrahari1",
		linkedin: "https://www.linkedin.com/in/vikas-agrahari-71540b223 ",
		instagram: "https://www.instagram.com/vikas04010/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "MERN Stack Developer",
		description:
		"I am a MERN Stack Developer skilled in building full-stack web applications using MongoDB, Express.js, React.js, and Node.js. I focus on developing scalable, efficient, and secure solutions that deliver great user experiences. I enjoy solving real-world problems, writing clean and maintainable code, and continuously improving my technical expertise. Always eager to learn new technologies and take on challenging projects that push my skills further.",
	},

	about: {
		title: "I’m Vikas Agrahari. I live in India, where I design the future.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Vedic Vision Frontend",
			description:
				"Developed a static website for Vedic Vision using HTML, CSS, and JavaScript. The site includes a clean, responsive layout, intuitive navigation, and basic interactive elements to enhance user experience. Focused on optimizing load speed, maintaining semantic HTML structure, and ensuring cross-device compatibility.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://vikas-agrahari1.github.io/Web_front/",
		},

		{
			title: "Swiggy Clone",
			description:
				"Built a front-end clone of Swiggy using React.js, Tailwind CSS, and JavaScript. Implemented responsive UI components, image-based menus, and dynamic sections to simulate a real food delivery platform. Focused on maintaining a scalable component structure, clean code practices, and cross-device compatibility.",
			logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
			linkText: "View Project",
			link: "https://swigi-clone-mu.vercel.app/",
		},

		{
			title: "Quiz Application",
			description:
				"Developed a web-based quiz app using HTML, CSS, and JavaScript. Implemented dynamic question rendering, score calculation, and interactive UI elements. Ensured a responsive layout and smooth user experience across devices.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png",
			linkText: "View Project",
			link: "https://vikas-agrahari1.github.io/Quiz_App/",
		},
	],
};

export default INFO;
